module.exports = __webpack_public_path__ + "img/pluga.4911cee8.png";